import React from 'react';
import { Modal, Button } from 'react-bootstrap';
function TranscriptionModal({ show, onHide, onConfirm }) {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Body>
        {' '}
        L'utente ha richiesto l'attivazione del servizio di sottotitolazione. Sei sicuro di voler
        procedere?{' '}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancella
        </Button>
        <Button variant="primary" onClick={onConfirm}>
          Conferma
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default TranscriptionModal;
